/* eslint-disable no-unused-expressions */
/* eslint-disable import/prefer-default-export */
import React, { useEffect } from 'react';
import ValesNoActivados from './ValesNoActivados';
import VerMasVales from './VerMasVales';
import ValesPreActivados from './ValesPreActivados';
import ValesActivados from './ValesActivados';
import ValesCanjeados from './ValesCanjeados';
import { useValeContext } from '../context/Vale.context';
import { ValesData } from '../../../types/Types';
import { FiltersConstants } from '../../../utils/FiltersConstants';

const ValeCoreBody = (props) => {
  const {
    valesNoAct,
    isMobile,
    handleVerMasClick,
    valesPreAct,
    valesAct,
    valesCanj,
    existVales,
  } = props;

  const {
    activeFilters,
    filtrosOtrosActivos,
    filtrarTodosLosCupones,
    voucherNotActWithFilterApplied,
    hideLsFiltradaNoActivados,
    hideLsFiltradaActivados,
    hideLsFiltradaCanjeados,
    voucherActWithFilterApplied,
    voucherCanjWithFilterApplied,
    voucherPromoWithFilterApplied,
    valesVisiblesSFNoActivados,
    valesVisiblesSFActivados,
    valesVisiblesSFCanjeados,
    valesVisiblesSFPromos,
    loadValesVisiblesNoFiltrados,
    loadHideLsNoActivados,
    loadHideLsPreactiva2,
    loadHideLsActivados,
    loadHideLsCanjeados,
    filtrosProductos,
    filtrosOtrosAMostrar,
  } = useValeContext();

  const showVerMasNoActivado = () => {
    const areHidden = valesNoAct.length !== valesVisiblesSFNoActivados.length;
    const showBtnVerMas =
      valesNoAct.length > FiltersConstants.NUM_CUPONES_MOSTRADOS_AL_INICIO &&
      !isMobile &&
      areHidden;
    return showBtnVerMas;
  };
  const valesPreActExistsAndGreaterZero = () => {
    return valesPreAct?.length > 0;
  };
  const showVerMasPreAct = () => {
    const areHidden = valesPreAct.length !== valesVisiblesSFPromos.length;
    const showBtnVerMas =
      valesPreAct.length > FiltersConstants.NUM_CUPONES_MOSTRADOS_AL_INICIO &&
      !isMobile &&
      areHidden;
    return showBtnVerMas;
  };

  const showVerMasAct = () => {
    const areHidden = valesAct.length !== valesVisiblesSFActivados.length;
    const showBtnVerMas =
      valesAct.length > FiltersConstants.NUM_CUPONES_MOSTRADOS_AL_INICIO &&
      !isMobile &&
      areHidden;
    return showBtnVerMas;
  };

  const showVerMasCanjeados = () => {
    const areHidden = valesCanj.length !== valesVisiblesSFCanjeados.length;
    const showBtnVerMas =
      valesCanj.length > FiltersConstants.NUM_CUPONES_MOSTRADOS_AL_INICIO &&
      !isMobile &&
      areHidden;
    return showBtnVerMas;
  };

  useEffect(() => {
    filtrarTodosLosCupones(
      valesVisiblesSFNoActivados,
      valesVisiblesSFActivados,
      valesVisiblesSFCanjeados,
      valesVisiblesSFPromos,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeFilters, filtrosOtrosActivos]);
  const isFiltroActivado =
    activeFilters.length > 0 || filtrosOtrosActivos.length > 0;
  let newProps = props;
  if (isFiltroActivado) {
    newProps = {
      ...newProps,
      valesNoAct: voucherNotActWithFilterApplied,
      valesAct: voucherActWithFilterApplied,
      valesCanj: voucherCanjWithFilterApplied,
      valesPreAct: voucherPromoWithFilterApplied,
    };
  }

  function getCuponByEAN(cuponHTML: Element, vales: ValesData[]) {
    const cuponesMapeados: ValesData[] = [];
    const idEan = cuponHTML.getAttribute(FiltersConstants.ATRIBUTO_DATA_ID);
    let m = 0;
    while (m < vales.length) {
      if (idEan === vales[m].valeEAN) {
        cuponesMapeados.push(vales[m]);
        m = vales.length;
      }
      m += 1;
    }
    return cuponesMapeados[0];
  }

  function isCuponExistente(valesLsOrigen: ValesData[], idEan: string) {
    let isCuponIncluido = false;
    let j = 0;
    if (valesLsOrigen[j]) {
      while (j < valesLsOrigen.length) {
        if (valesLsOrigen[j].valeEAN === idEan) {
          isCuponIncluido = true;
          j = valesLsOrigen.length;
        }
        j += 1;
      }
    }
    return isCuponIncluido;
  }

  function addCuponNewLs(
    cuponHtml: Element,
    newLsCupones: ValesData[],
    valesLsOrigen: ValesData[],
  ) {
    const cupon: ValesData = getCuponByEAN(cuponHtml, valesLsOrigen);
    const idEan = cupon && cupon.valeEAN;
    if (!isCuponExistente(newLsCupones, idEan)) {
      newLsCupones.push(cupon);
    }
  }

  function getCuponesFromHtml(selectorShowHide: string) {
    const valesLsHtml = document.querySelectorAll(
      `.bloque-vale__total.${selectorShowHide}`,
    );
    let i = 0;
    const newLsNoActivados: ValesData[] = [];
    const newLsPreactiva2: ValesData[] = [];
    const newLsActivados: ValesData[] = [];
    const newLsCanjeados: ValesData[] = [];
    while (i < valesLsHtml.length) {
      const tipoLista = valesLsHtml[i].getAttribute(
        FiltersConstants.ATRIBUTO_DATA_TIPO_LISTA,
      );
      if (tipoLista === '1') {
        addCuponNewLs(valesLsHtml[i], newLsNoActivados, valesNoAct);
      } else if (tipoLista === '2') {
        addCuponNewLs(valesLsHtml[i], newLsActivados, valesAct);
      } else if (tipoLista === '3') {
        addCuponNewLs(valesLsHtml[i], newLsCanjeados, valesCanj);
      } else if (tipoLista === '4') {
        addCuponNewLs(valesLsHtml[i], newLsPreactiva2, valesPreAct);
      }
      i += 1;
    }
    return {
      newLsNoActivados,
      newLsPreactiva2,
      newLsActivados,
      newLsCanjeados,
    };
  }

  function mostrarValesHtml(lsValesVisibles: ValesData[]) {
    lsValesVisibles.map((vale) => {
      const cuponHtml = document.querySelector(`[data-id='${vale.valeEAN}']`);
      cuponHtml?.classList.remove(FiltersConstants.SELECTOR_CUPONES_VISIBLES);
      cuponHtml?.classList.remove(FiltersConstants.SELECTOR_CUPONES_OCULTOS);
      cuponHtml?.classList.add(FiltersConstants.SELECTOR_CUPONES_VISIBLES);
      return true;
    });
  }

  function vaciarFiltrosActivos() {
    if (activeFilters.length > 0) {
      activeFilters.length = 0;
    }
    if (filtrosOtrosActivos.length > 0) {
      filtrosOtrosActivos.length = 0;
    }
  }
  function vaciarListadoFiltros() {
    if (filtrosProductos.length > 0) {
      filtrosProductos.length = 0;
    }
    if (filtrosOtrosAMostrar.length > 0) {
      filtrosOtrosAMostrar.length = 0;
    }
  }

  const handleMapearCuponesOcultosYVisibles = () => {
    if (activeFilters.length === 0 && filtrosOtrosActivos.length === 0) {
      const {
        newLsNoActivados: newLsVisiblesNoActivados,
        newLsPreactiva2: newLsVisiblesPreactiva2,
        newLsActivados: newLsVisiblesActivados,
        newLsCanjeados: newLsVisiblesCanjeados,
      } = getCuponesFromHtml(FiltersConstants.SELECTOR_CUPONES_VISIBLES);
      const {
        newLsNoActivados: newLsOcultossNoActivados,
        newLsPreactiva2: newLsOcultossPreactiva2,
        newLsActivados: newLsOcultossActivados,
        newLsCanjeados: newLsOcultossCanjeados,
      } = getCuponesFromHtml(FiltersConstants.SELECTOR_CUPONES_OCULTOS);

      loadValesVisiblesNoFiltrados(
        newLsVisiblesNoActivados,
        newLsVisiblesActivados,
        newLsVisiblesCanjeados,
        newLsVisiblesPreactiva2,
      );
      loadHideLsNoActivados(newLsOcultossNoActivados);
      loadHideLsPreactiva2(newLsOcultossPreactiva2);
      loadHideLsActivados(newLsOcultossActivados);
      loadHideLsCanjeados(newLsOcultossCanjeados);
      filtrarTodosLosCupones(
        valesVisiblesSFNoActivados,
        valesVisiblesSFActivados,
        valesVisiblesSFCanjeados,
        valesVisiblesSFPromos,
      );
    }
  };
  useEffect(() => {
    if (existVales) {
      handleMapearCuponesOcultosYVisibles();
    } else {
      vaciarListadoFiltros();
    }
    vaciarFiltrosActivos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [existVales]);
  useEffect(() => {
    if (activeFilters.length > 0 || filtrosOtrosActivos.length > 0) {
      mostrarValesHtml(voucherNotActWithFilterApplied);
      mostrarValesHtml(voucherActWithFilterApplied);
      mostrarValesHtml(voucherCanjWithFilterApplied);
      mostrarValesHtml(voucherPromoWithFilterApplied);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeFilters, filtrosOtrosActivos]);

  return (
    <>
      <>
        {!isFiltroActivado ? (
          <>
            <ValesNoActivados {...props} />
            {showVerMasNoActivado() && (
              <VerMasVales id={1} handleVerMasClick={handleVerMasClick} />
            )}
          </>
        ) : (
          <>
            {isFiltroActivado ? (
              <>
                <ValesNoActivados {...newProps} />
                {showVerMasNoActivado() &&
                  hideLsFiltradaNoActivados.length > 0 && (
                    <VerMasVales id={1} handleVerMasClick={handleVerMasClick} />
                  )}
              </>
            ) : null}
          </>
        )}
      </>
      {valesPreActExistsAndGreaterZero() && (
        <>
          {!isFiltroActivado ? (
            <>
              <ValesPreActivados {...props} />
              {showVerMasPreAct() && (
                <VerMasVales id={4} handleVerMasClick={handleVerMasClick} />
              )}
            </>
          ) : (
            <>
              {isFiltroActivado ? (
                <>
                  <ValesPreActivados {...newProps} />
                  {showVerMasPreAct() && (
                    <VerMasVales id={4} handleVerMasClick={handleVerMasClick} />
                  )}
                </>
              ) : null}
            </>
          )}
        </>
      )}

      <>
        {!isFiltroActivado ? (
          <>
            <ValesActivados {...props} />
            {showVerMasAct() && (
              <VerMasVales id={2} handleVerMasClick={handleVerMasClick} />
            )}
          </>
        ) : (
          <>
            {isFiltroActivado ? (
              <>
                <ValesActivados {...newProps} />
                {showVerMasAct() && hideLsFiltradaActivados.length > 0 && (
                  <VerMasVales id={2} handleVerMasClick={handleVerMasClick} />
                )}
              </>
            ) : null}
          </>
        )}
      </>

      <>
        {!isFiltroActivado ? (
          <>
            <ValesCanjeados {...props} />
            {showVerMasCanjeados() && (
              <VerMasVales id={3} handleVerMasClick={handleVerMasClick} />
            )}
          </>
        ) : (
          <>
            {isFiltroActivado ? (
              <>
                <ValesCanjeados {...newProps} />
                {showVerMasCanjeados() &&
                  hideLsFiltradaCanjeados.length > 0 && (
                    <VerMasVales id={3} handleVerMasClick={handleVerMasClick} />
                  )}
              </>
            ) : null}
          </>
        )}
      </>
    </>
  );
};

export default ValeCoreBody;
